import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { Button, ListGroup, Modal, OverlayTrigger, Popover } from "react-bootstrap";
import PageTitle from "../../components/PageTitle/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import { permissionsInterface } from "../onBoarding/onBoardingTypes";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import routePaths from "../../Navigation/routePaths";
import { TbBrandBooking } from "react-icons/tb";

interface IPlotData {
    id: number;
    coordinates: number[][];
    color: string;
    title: string;
    facing_direction?: string;
    area?: string;
    status?: string;
};

const FloorStatusView = () => {
    const navigate = useNavigate();
    const dispath = useDispatch();
    const { floor_id, tower_id, project_id } = useParams();
    const [plotData, setPlotData] = useState<IPlotData[]>([]);
    const [fullPageLoder, setFullPageLoder] = useState(false);
    const [floorImage, setFloorImage] = useState<string>("");
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
    const [towerInfo, setTowerInfo] = useState<any>(null);
    const [showFloorInfo, setShowFloorInfo] = useState<boolean>(false);
    const [unitInfo, setUnitInfo] = useState<any | null>(null);
    const [bookingPermissions, setBookingPermissions] = useState<permissionsInterface | null>(null);

    useEffect(() => {
        if (token && token.token && token.permissions && !!token.permissions.length) {
            setPermissions(token.permissions.find((item: any) => item.name === "PROJECTS"));
            setBookingPermissions(token.permissions.find((item: any) => item.name === "BOOKINGS"));
        }
    }, [token]);

    useEffect(() => {
        if (permissions && permissions.can_read && tower_id && project_id) {
            getMarkingData();
        }
    }, [permissions]);

    const getMarkingData = () => {
        setFullPageLoder(true);
        WebService.getAPI({ action: `get/floor?project_uuid=${project_id}&tower_uuid=${tower_id}&floor_uuid=${floor_id}` })
            .then((res: any) => {
                setFullPageLoder(false);
                setTowerInfo(res.floor_info);
                const data: any = [];
                res.floor_info?.coordinates_data.map((item: any) => {
                    const project_units = res.floor_info?.floor_units.find((unit: any) => unit.id === item.unit_id);
                    data.push({ id: item.id, uuid: item.uuid, coordinates: item.coordinates, color: project_units?.status == "SOLD" ? "rgba(255, 0, 0, 0.6)" : "rgba(50, 205, 50, 0.2)", title: project_units?.unit_name, facing_direction: project_units?.facing_direction, area: project_units?.area, status: project_units?.status, tags: item.tags, project_units });
                });
                setPlotData(data);
                setFloorImage(res.floor_info?.floor_image);
            })
            .catch((e: any) => { setFullPageLoder(false); });
    };

    const onClickUnit = (plot: any) => {
        setUnitInfo(plot);
        setShowFloorInfo(true);
    }

    const getUnitCountsByStatus = (unit_data: any) => {
        return <>
            <ListGroup.Item as="li" className="border-0 border-bottom">Length/Width: {unit_data?.project_units?.length}/{unit_data?.project_units?.width}</ListGroup.Item>
            <ListGroup.Item as="li" className="border-0 border-bottom">Area: {unit_data?.project_units?.area}</ListGroup.Item>
            <ListGroup.Item as="li" className="border-0 border-bottom">Status: {unit_data?.project_units?.status}</ListGroup.Item>
            <ListGroup.Item as="li" className="border-0 border-bottom">Is Corner: {unit_data?.project_units?.is_corner ? "Yes" : "No"}</ListGroup.Item>
        </>;
    };

    const popoverHoverFocus = (plot: any) => {
        return (
            <Popover id="popover-basic" className="p-0">
                <ListGroup as="ul" className="border-0">
                    <ListGroup.Item as="li" className="border-0">Plot Name: {plot.title}</ListGroup.Item>
                    <ListGroup.Item as="li" className="border-0">Facing: {plot.facing_direction}</ListGroup.Item>
                    <ListGroup.Item as="li" className="border-0">Area: {plot.area}</ListGroup.Item>
                    <ListGroup.Item as="li" className="border-0">Status: {plot.status}</ListGroup.Item>
                    {
                        plot.status == "SOLD" &&
                        <>
                            <ListGroup.Item as="li" className="border-0">Customer: {plot?.project_units?.customer_name} ({plot?.project_units?.customer_phone})</ListGroup.Item>
                            <ListGroup.Item as="li" className="border-0">Agent: {plot?.project_units?.agent_name} ({plot?.project_units?.agent_phone})</ListGroup.Item>
                        </>
                    }
                    {
                        plot?.tags && !!plot?.tags.length && <ListGroup.Item as="li" className="border-0">Tags: {plot?.tags.join(", ")}</ListGroup.Item>
                    }
                    {/* {plot.status == "AVAILABLE" && bookingPermissions && bookingPermissions.can_write &&
                        <ListGroup.Item as="li" className="border-0 text-center cursor-pointer" style={{ backgroundColor: "#ffea9e", color: "rgb(255, 193, 7)" }} onClick={() => {
                            dispath({ type: "BOOKING_CREATE_OR_UPDATE_PAGE_REQUEST", payload: { data: { ...plot.project_units, ...{ project_unit_id: plot?.project_units?.id } }, isEdit: false } });
                            dispath({ type: "NAVIGATION_REQUEST", payload: routePaths.BOOKING_CREATE.path });
                        }}>
                            <span className="badge text-warning p-0"><TbBrandBooking size={18} /> Book Now</span>{" "}
                        </ListGroup.Item>} */}
                </ListGroup>
            </Popover>
        );
    };

    return (
        <div className="app-page">
            <div className="d-flex justify-content-between align-items-center "> <PageTitle title="Units Status" backArrow={true} /> </div>

            {permissions && permissions.can_read && towerInfo &&
                <div className="d-flex gap-2 mb-3">
                    <span className="badge bg-info text-white px-3 py-2 font-20">Total Units: {towerInfo.total_units}</span>
                    <span className="badge bg-success text-white px-3 py-2 font-20">Available: {towerInfo.available_units}</span>
                    <span className="badge bg-danger text-white px-3 py-2 font-20">Sold: {towerInfo.sold_units}</span>
                </div>
            }

            {permissions && permissions.can_read && <div style={{ height: "800px", width: "1250px", overflow: "auto" }}>
                <TransformWrapper>
                    <TransformComponent>
                        <svg style={{ height: "600px", width: "1250px", backgroundImage: `url(${floorImage})`, backgroundRepeat: "no-repeat", padding: "0px" }}>
                            {plotData && !!plotData.length && plotData.map((plot: any) => {
                                const points = plot.coordinates.map(([x, y]: any) => `${x},${y}`).join(" ");
                                return (
                                    <OverlayTrigger trigger={'hover'} placement="right" overlay={popoverHoverFocus(plot)} key={plot.id} >
                                        <g style={{ cursor: "pointer" }} onClick={() => onClickUnit(plot)}>
                                            <polygon points={points}
                                                fill={plot.color}
                                                // fill={'rgba(117, 190, 218, 0.2)'}
                                                stroke={''} strokeWidth="2" />
                                            {/* Calculate text width and polygon bounding box */}
                                            {(() => {
                                                // Calculate polygon centroid for better center placement
                                                const getPolygonCentroid = (coords: [number, number][]) => {
                                                    let x = 0, y = 0, area = 0;
                                                    const n = coords.length;
                                                    for (let i = 0; i < n; i++) {
                                                        const [x0, y0] = coords[i];
                                                        const [x1, y1] = coords[(i + 1) % n];
                                                        const a = x0 * y1 - x1 * y0;
                                                        area += a;
                                                        x += (x0 + x1) * a;
                                                        y += (y0 + y1) * a;
                                                    }
                                                    area *= 0.5;
                                                    if (area === 0) return [coords[0][0], coords[0][1]];
                                                    x /= (6 * area);
                                                    y /= (6 * area);
                                                    return [x, y];
                                                };
                                                const [centroidX, centroidY] = getPolygonCentroid(plot.coordinates);

                                                // Estimate text width (simple approximation: 8px per character)
                                                const textWidth = plot.title ? plot.title.length * 8 : 40;
                                                // Find bounding box of polygon
                                                const xs = plot.coordinates.map(([x]: any) => x);
                                                const ys = plot.coordinates.map(([, y]: any) => y);
                                                const minX = Math.min(...xs);
                                                const maxX = Math.max(...xs);
                                                const minY = Math.min(...ys);
                                                const maxY = Math.max(...ys);
                                                const boxWidth = maxX - minX;
                                                const boxHeight = maxY - minY;
                                                // Set background width: min(boxWidth, textWidth + padding)
                                                const bgWidth = Math.min(boxWidth, textWidth + 16);
                                                const bgHeight = Math.min(boxHeight, 28);

                                                return (
                                                    <>
                                                        <rect x={centroidX - bgWidth / 2} y={centroidY - bgHeight / 2} width={bgWidth} height={bgHeight} fill="rgba(117, 190, 218, 0.4)" rx={6} />
                                                        <text x={centroidX} y={centroidY} fill="#fff" fontSize="14" fontWeight="bold" textAnchor="middle" dominantBaseline="middle">
                                                            {plot.title}
                                                        </text>
                                                    </>
                                                );
                                            })()}
                                        </g>
                                    </OverlayTrigger>
                                );
                            })}
                        </svg>
                    </TransformComponent>
                </TransformWrapper>
            </div >}

            <Modal show={showFloorInfo} onHide={() => { setShowFloorInfo(false); setUnitInfo(null); }}
                aria-labelledby="contained-modal-title-vcenter"
                centered >
                <Modal.Header closeButton>
                    <Modal.Title>Unit Information</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {unitInfo &&
                        <>
                            <h6 className="text-center font-22 font-bold text-success">{unitInfo.project_units?.unit_name}</h6>
                            <ListGroup as="ul" className="border-0">
                                {getUnitCountsByStatus(unitInfo)}
                            </ListGroup>
                            {unitInfo.project_units?.status == "AVAILABLE" && <div className="text-center">
                                <Button variant="info" className="mt-3 text-center" onClick={() => {
                                    dispath({ type: "BOOKING_CREATE_OR_UPDATE_PAGE_REQUEST", payload: { data: { ...unitInfo.project_units, ...{ project_unit_id: unitInfo?.project_units?.id } }, isEdit: false } });
                                    dispath({ type: "NAVIGATION_REQUEST", payload: routePaths.BOOKING_CREATE.path });
                                }}>
                                    <span className="badge text-white p-0"><TbBrandBooking size={18} /> Book Now</span>
                                </Button>
                            </div>}
                        </>
                    }
                </Modal.Body>
            </Modal>

        </div>

    );
};

export default FloorStatusView;